interface Props {
  className?: string
}
export const ArrowRight = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={7}
      height={12}
      viewBox='0 0 7 12'
      fill='none'
    >
      <path
        d='M0.2925 0.310364C-0.0975 0.700364 -0.0975 1.33036 0.2925 1.72036L4.1725 5.60036L0.2925 9.48036C-0.0975 9.87036 -0.0975 10.5004 0.2925 10.8904C0.6825 11.2804 1.3125 11.2804 1.7025 10.8904L6.2925 6.30036C6.6825 5.91036 6.6825 5.28036 6.2925 4.89036L1.7025 0.300364C1.3225 -0.0796364 0.6825 -0.0796361 0.2925 0.310364Z'
        fill='#919499'
      />
    </svg>
  )
}
export const Location = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 0C7.11133 0 3.13428 3.97705 3.13428 8.86571C3.13428 10.4751 3.85605 12.206 3.8863 12.279C4.11941 12.8323 4.57939 13.6918 4.91107 14.1956L10.9898 23.406C11.2386 23.7836 11.6068 24 12 24C12.3932 24 12.7614 23.7836 13.0102 23.4065L19.0894 14.1956C19.4216 13.6918 19.8811 12.8323 20.1142 12.279C20.1444 12.2065 20.8657 10.4756 20.8657 8.86571C20.8657 3.97705 16.8886 0 12 0ZM19.1525 11.8743C18.9444 12.3703 18.5163 13.1698 18.2185 13.6214L12.1392 22.8323C12.0193 23.0143 11.9812 23.0143 11.8613 22.8323L5.782 13.6214C5.48421 13.1698 5.05605 12.3698 4.84797 11.8738C4.8391 11.8524 4.1773 10.2592 4.1773 8.86571C4.1773 4.55228 7.68656 1.04302 12 1.04302C16.3134 1.04302 19.8227 4.55228 19.8227 8.86571C19.8227 10.2613 19.1593 11.8587 19.1525 11.8743Z'
        fill='black'
      />
      <path
        d='M12 4.17261C9.41174 4.17261 7.3064 6.27847 7.3064 8.86622C7.3064 11.454 9.41174 13.5598 12 13.5598C14.5883 13.5598 16.6936 11.454 16.6936 8.86622C16.6936 6.27847 14.5883 4.17261 12 4.17261ZM12 12.5168C9.98749 12.5168 8.34942 10.8793 8.34942 8.86622C8.34942 6.85318 9.98749 5.21563 12 5.21563C14.0125 5.21563 15.6506 6.85318 15.6506 8.86622C15.6506 10.8793 14.0125 12.5168 12 12.5168Z'
        fill='black'
      />
    </svg>
  )
}

export const LocationBlack = ({color= '#4294FE'}:{color?:string}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 17 17'
      fill='none'
    >
      <g clipPath='url(#clip0_223_12540)'>
        <path
          d='M8.43848 0.184082C6.84783 0.186192 5.32293 0.819011 4.19817 1.94377C3.07341 3.06853 2.44059 4.59343 2.43848 6.18408C2.43848 10.4916 8.02848 15.8866 8.26598 16.1141C8.31217 16.159 8.37406 16.1841 8.43848 16.1841C8.5029 16.1841 8.56478 16.159 8.61098 16.1141C8.84848 15.8866 14.4385 10.4916 14.4385 6.18408C14.4364 4.59343 13.8035 3.06853 12.6788 1.94377C11.554 0.819011 10.0291 0.186192 8.43848 0.184082ZM8.43848 8.93408C7.89458 8.93408 7.36289 8.7728 6.91066 8.47062C6.45842 8.16845 6.10595 7.73896 5.89781 7.23646C5.68967 6.73397 5.63521 6.18103 5.74132 5.64758C5.84743 5.11414 6.10934 4.62413 6.49393 4.23954C6.87853 3.85494 7.36853 3.59303 7.90198 3.48692C8.43543 3.38081 8.98836 3.43527 9.49086 3.64341C9.99335 3.85155 10.4228 4.20403 10.725 4.65626C11.0272 5.1085 11.1885 5.64018 11.1885 6.18408C11.188 6.91329 10.8982 7.61251 10.3825 8.12814C9.86691 8.64377 9.16769 8.93365 8.43848 8.93408Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_223_12540'>
          <rect
            width={16}
            height={16}
            fill='white'
            transform='translate(0.438477 0.184082)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
export const FreeShip = ({ className }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={21}
      height={21}
      viewBox='0 0 21 21'
      fill='none'
      className={className}
    >
      <mask
        id='mask0_8_2739'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={21}
        height={21}
      >
        <path
          d='M0.867188 0.304688H20.8672V20.3047H0.867188V0.304688Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_8_2739)'>
        <path
          d='M18.34 5.43524C19.5382 5.31356 20.4733 4.30157 20.4733 3.07121C20.4733 1.75879 19.4094 0.694886 18.097 0.694886C16.7846 0.694886 15.7207 1.75879 15.7207 3.07121C15.7207 3.72739 15.9866 4.32145 16.4166 4.75145'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5.98043 12.8742L5.04004 13.8146L7.36023 16.1348'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.17773 14.9521L7.0434 14.0864'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.78516 12.4946L10.8672 12.6274'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.29199 11.5618L9.61219 13.882'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.14965 10.9106C9.48266 11.2436 9.46063 11.8056 9.11551 12.1507C8.94438 12.3218 8.50594 12.7656 8.50594 12.7656C8.50594 12.7656 8.06539 12.3306 7.8975 12.1627C7.75965 12.0248 7.29297 11.5613 7.29297 11.5613C7.29297 11.5613 7.7073 11.147 7.90953 10.9447C8.25465 10.5996 8.81664 10.5776 9.14965 10.9106Z'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.0528 5.80108L12.0752 6.7787L14.3954 9.09889L15.373 8.12127'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.1409 7.03329L13.2354 7.93884'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.7872 8.0667L9.80957 9.04432L12.1298 11.3645L13.1074 10.3869'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.8753 9.29891L10.9697 10.2045'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.6147 13.9493L17.8405 10.7234C18.1335 10.4304 18.2981 10.033 18.2981 9.6186V4.44048C18.2981 3.57755 17.5986 2.87798 16.7356 2.87798H11.555C11.1407 2.87798 10.7433 3.04255 10.4503 3.33552L1.71754 12.0662C1.10723 12.6763 1.10715 13.6658 1.71743 14.276L6.89782 19.4564C7.50801 20.0666 8.49735 20.0666 9.10754 19.4564L12.1288 16.4352'
          stroke='black'
          strokeMiterlimit={10}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
export const IconInstallment = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={36}
      height={36}
      viewBox='0 0 44 44'
      fill='none'
    >
      <path
        d='M21.6171 43.2826C33.4749 43.2826 43.0876 33.6699 43.0876 21.812C43.0876 9.95414 33.4749 0.341431 21.6171 0.341431C9.75919 0.341431 0.146484 9.95414 0.146484 21.812C0.146484 33.6699 9.75919 43.2826 21.6171 43.2826Z'
        fill='#FFD112'
      />
      <path
        d='M39.9238 10.4326C36.1059 16.4913 29.3337 20.5171 21.6172 20.5171C13.9006 20.5171 7.12838 16.4913 3.31055 10.4326C7.12163 4.37388 13.9006 0.341431 21.6172 0.341431C29.3337 0.341431 36.1127 4.37388 39.9238 10.4326Z'
        fill='#FFE955'
      />
      <g opacity='0.1'>
        <path
          d='M35.0146 37.8361C35.0146 38.3119 29.015 38.6979 21.6167 38.6979C14.2183 38.6979 8.21875 38.3119 8.21875 37.8361C8.21875 37.3602 14.2183 36.9795 21.6167 36.9795C29.015 36.9795 35.0146 37.3602 35.0146 37.8361Z'
          fill='black'
        />
      </g>
      <path
        d='M21.6187 33.3718C27.946 33.3718 33.0752 28.2426 33.0752 21.9153C33.0752 15.588 27.946 10.4587 21.6187 10.4587C15.2914 10.4587 10.1621 15.588 10.1621 21.9153C10.1621 28.2426 15.2914 33.3718 21.6187 33.3718Z'
        fill='white'
      />
      <path
        d='M27.7657 22.1497H21.6184C21.4886 22.1497 21.3838 22.0449 21.3838 21.9152C21.3838 21.7854 21.4886 21.6806 21.6184 21.6806H27.7657C27.8955 21.6806 28.0003 21.7854 28.0003 21.9152C28.0003 22.0449 27.8955 22.1497 27.7657 22.1497Z'
        fill='#FF3445'
      />
      <path
        d='M21.7537 22.2514L16.3754 27.6255C16.2346 27.7663 16.0043 27.7663 15.8635 27.6255C15.791 27.553 15.7568 27.4634 15.7568 27.3696C15.7568 27.2757 15.791 27.1862 15.8635 27.1136L21.2419 21.7395C21.3784 21.5987 21.6087 21.5987 21.7495 21.7395C21.8902 21.8803 21.8945 22.1106 21.7537 22.2514Z'
        fill='#20273A'
      />
      <path
        d='M17.5205 15.0516C17.4392 15.0516 17.3606 15.0097 17.3173 14.9343L16.516 13.5466C16.4511 13.4345 16.4891 13.291 16.6018 13.2262C16.7132 13.16 16.858 13.1999 16.9222 13.312L17.7236 14.6998C17.7885 14.8118 17.7505 14.9553 17.6378 15.0202C17.6011 15.0418 17.5604 15.0516 17.5205 15.0516Z'
        fill='#20273A'
      />
      <path
        d='M26.5175 30.6349C26.4369 30.6349 26.3577 30.593 26.3144 30.5176L25.5131 29.1305C25.4482 29.0185 25.4862 28.875 25.5989 28.8101C25.7096 28.7446 25.8544 28.7832 25.9193 28.8959L26.7207 30.2831C26.7855 30.3951 26.7475 30.5386 26.6348 30.6035C26.5981 30.6251 26.5575 30.6349 26.5175 30.6349Z'
        fill='#20273A'
      />
      <path
        d='M14.52 18.0513C14.48 18.0513 14.4394 18.0415 14.4027 18.0198L13.0149 17.2191C12.9022 17.1549 12.8642 17.0108 12.9291 16.8987C12.9933 16.7867 13.1381 16.7474 13.2495 16.8129L14.6373 17.6136C14.75 17.6778 14.788 17.822 14.7231 17.934C14.6799 18.0093 14.6012 18.0513 14.52 18.0513Z'
        fill='#20273A'
      />
      <path
        d='M30.104 27.0489C30.064 27.0489 30.0234 27.0391 29.9867 27.0174L28.5989 26.2161C28.4862 26.1512 28.4482 26.0077 28.5131 25.8957C28.5779 25.783 28.7221 25.7443 28.8335 25.8098L30.2213 26.6112C30.334 26.6761 30.372 26.8195 30.3071 26.9316C30.2638 27.0069 30.1852 27.0489 30.104 27.0489Z'
        fill='#20273A'
      />
      <path
        d='M13.4225 22.1497H11.8205C11.6908 22.1497 11.5859 22.0449 11.5859 21.9152C11.5859 21.7854 11.6908 21.6806 11.8205 21.6806H13.4225C13.5523 21.6806 13.6571 21.7854 13.6571 21.9152C13.6571 22.0449 13.5523 22.1497 13.4225 22.1497Z'
        fill='#20273A'
      />
      <path
        d='M31.4167 22.1498H29.8147C29.6849 22.1498 29.5801 22.0449 29.5801 21.9152C29.5801 21.7855 29.6849 21.6806 29.8147 21.6806H31.4167C31.5464 21.6806 31.6513 21.7855 31.6513 21.9152C31.6513 22.0449 31.5464 22.1498 31.4167 22.1498Z'
        fill='#20273A'
      />
      <path
        d='M13.1322 27.0489C13.051 27.0489 12.9723 27.007 12.9291 26.9317C12.8642 26.8196 12.9022 26.6761 13.0149 26.6112L14.4027 25.8099C14.5141 25.7444 14.6582 25.783 14.7231 25.8957C14.788 26.0078 14.75 26.1513 14.6373 26.2161L13.2495 27.0175C13.2128 27.0391 13.1722 27.0489 13.1322 27.0489Z'
        fill='#20273A'
      />
      <path
        d='M28.7162 18.0513C28.6349 18.0513 28.5563 18.0094 28.5131 17.934C28.4482 17.822 28.4862 17.6778 28.5989 17.6136L29.9867 16.8129C30.0981 16.7474 30.2429 16.7867 30.3071 16.8988C30.372 17.0108 30.334 17.155 30.2213 17.2192L28.8335 18.0199C28.7968 18.0415 28.7562 18.0513 28.7162 18.0513Z'
        fill='#20273A'
      />
      <path
        d='M16.7191 30.6349C16.6792 30.6349 16.6385 30.6251 16.6018 30.6035C16.4891 30.5386 16.4511 30.3951 16.516 30.2831L17.3173 28.8959C17.3822 28.7832 17.5264 28.7446 17.6378 28.8101C17.7505 28.875 17.7885 29.0185 17.7236 29.1305L16.9222 30.5176C16.879 30.593 16.7997 30.6349 16.7191 30.6349Z'
        fill='#20273A'
      />
      <path
        d='M25.7162 15.0516C25.6762 15.0516 25.6356 15.0418 25.5989 15.0201C25.4862 14.9553 25.4482 14.8118 25.5131 14.6997L26.3144 13.312C26.3786 13.1999 26.5234 13.1599 26.6348 13.2261C26.7475 13.291 26.7855 13.4345 26.7207 13.5465L25.9193 14.9343C25.8761 15.0097 25.7974 15.0516 25.7162 15.0516Z'
        fill='#20273A'
      />
      <path
        d='M21.6184 31.9481C21.4886 31.9481 21.3838 31.8432 21.3838 31.7135V30.1108C21.3838 29.9811 21.4886 29.8762 21.6184 29.8762C21.7481 29.8762 21.8529 29.9811 21.8529 30.1108V31.7135C21.8529 31.8432 21.7481 31.9481 21.6184 31.9481Z'
        fill='#20273A'
      />
      <path
        d='M22.074 15.6949V22.5879H21.1621V15.6949C21.1621 15.4458 21.369 15.2432 21.6181 15.2432C21.8671 15.2432 22.074 15.4458 22.074 15.6949Z'
        fill='#20273A'
      />
      <path
        d='M21.619 23.2921C22.3794 23.2921 22.9958 22.6756 22.9958 21.9153C22.9958 21.1549 22.3794 20.5385 21.619 20.5385C20.8586 20.5385 20.2422 21.1549 20.2422 21.9153C20.2422 22.6756 20.8586 23.2921 21.619 23.2921Z'
        fill='#20273A'
      />
      <path
        d='M21.6187 22.5144C21.9496 22.5144 22.2179 22.2461 22.2179 21.9152C22.2179 21.5843 21.9496 21.3161 21.6187 21.3161C21.2878 21.3161 21.0195 21.5843 21.0195 21.9152C21.0195 22.2461 21.2878 22.5144 21.6187 22.5144Z'
        fill='white'
      />
      <path
        d='M35.9597 21.9118C35.9597 29.829 29.5387 36.2567 21.6148 36.2567C13.6907 36.2567 7.27637 29.829 7.27637 21.9118C7.27637 17.1681 9.5845 12.9544 13.1405 10.3445L14.9454 12.6055C12.0469 14.6788 10.1615 18.0738 10.1615 21.9118C10.1615 28.2388 15.2876 33.3717 21.6148 33.3717C27.9486 33.3717 33.0746 28.2388 33.0746 21.9118C33.0746 16.7521 29.6662 12.3909 24.9695 10.9617C23.9094 10.633 22.7822 10.4585 21.6148 10.4585V12.7867C21.6148 13.2765 21.0645 13.5516 20.6686 13.2698L15.5627 9.57279C15.234 9.33134 15.234 8.84148 15.5627 8.59994L20.6686 4.88954C21.0645 4.60779 21.6148 4.88954 21.6148 5.37261V7.57336C22.7688 7.57336 23.896 7.7076 24.9695 7.96928C31.2765 9.47893 35.9597 15.1485 35.9597 21.9118Z'
        fill='#1076E5'
      />
    </svg>
  )
}
export const IconBNPL = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={38}
      height={38}
      viewBox='0 0 38 38'
      fill='none'
    >
      <path
        d='M36.3483 31.7285C36.3268 31.7285 25.3808 36.1861 23.4701 36.946C23.2963 37.0113 23.2095 37.0545 23.188 37.0545C20.7564 38.1618 17.5652 38.14 14.96 36.8159L5.0166 32.8573V21.1124L11.2257 20.2004C12.333 19.8965 13.3967 20.0051 14.3519 20.4828C14.569 20.5914 22.8406 24.7378 23.3616 24.9984C23.4051 25.0202 23.4483 25.0419 23.4701 25.0637C24.4471 25.5847 24.838 26.8437 24.3167 27.9075C24.1214 28.2984 23.8175 28.6241 23.4701 28.8194C22.8623 29.1668 22.1025 29.2101 21.4077 28.863C21.1908 28.7544 17.3695 26.8655 17.3695 26.8655C16.0019 26.1924 14.3519 26.5616 13.3967 27.7557C13.0058 28.2331 13.0928 28.9062 13.5703 29.2754C14.0265 29.6443 14.7211 29.5793 15.09 29.1015C15.4156 28.7109 15.9584 28.5806 16.4361 28.7977L20.4307 30.8166C21.0602 31.1205 21.7333 31.2725 22.3846 31.2725C22.5149 31.2725 22.9056 31.1858 23.4701 31.034C26.5313 30.2306 34.7636 27.7122 34.7636 27.7122C35.8708 27.3432 37.0214 27.9075 37.4556 28.9062C37.9333 29.7096 37.5426 31.2072 36.3483 31.7285Z'
        fill='#FFCEBF'
      />
      <path
        d='M36.3489 31.7285C36.3274 31.7285 25.3814 36.1861 23.4707 36.946V31.0337C26.5319 30.2306 34.7642 27.7122 34.7642 27.7122C35.8714 27.343 37.0219 27.9075 37.4561 28.9062C37.9339 29.7096 37.5432 31.2073 36.3489 31.7285Z'
        fill='#FFBFAB'
      />
      <path
        d='M23.4707 0.806152C18.0867 0.806152 13.7012 5.26406 13.7012 10.648C13.7012 16.032 18.0867 20.4175 23.4707 20.4175C28.8547 20.4175 33.2402 16.032 33.2402 10.648C33.2402 5.26406 28.8547 0.806152 23.4707 0.806152Z'
        fill='#FFE470'
      />
      <path
        d='M23.4707 20.4175V0.806152C28.8547 0.806152 33.2402 5.26406 33.2402 10.648C33.2402 16.032 28.8547 20.4175 23.4707 20.4175Z'
        fill='#FFD400'
      />
      <path
        d='M23.4706 2.97716C19.2807 2.97716 15.8721 6.45811 15.8721 10.648C15.8721 14.838 19.2807 18.2465 23.4706 18.2465C27.6605 18.2465 31.0691 14.838 31.0691 10.648C31.0691 6.45811 27.6605 2.97716 23.4706 2.97716Z'
        fill='#FDBF00'
      />
      <path
        d='M31.0692 10.648C31.0692 14.838 27.6606 18.2465 23.4707 18.2465V2.97716C27.6606 2.97716 31.0692 6.45811 31.0692 10.648Z'
        fill='#FF9F00'
      />
      <path
        d='M26.7269 12.819C26.7269 14.2302 25.8152 15.4242 24.5559 15.8802V17.161C24.5559 17.7691 24.0784 18.2465 23.4704 18.2465C22.8623 18.2465 22.3849 17.7691 22.3849 17.161V15.8802C21.1255 15.4242 20.2139 14.2302 20.2139 12.819C20.2139 12.211 20.6913 11.7335 21.2994 11.7335C21.9074 11.7335 22.3849 12.211 22.3849 12.819C22.3849 13.4271 22.8623 13.9045 23.4704 13.9045C24.0784 13.9045 24.5559 13.4271 24.5559 12.819C24.5559 12.211 24.0784 11.7335 23.4704 11.7335C21.6683 11.7335 20.2139 10.2791 20.2139 8.47703C20.2139 7.06588 21.1255 5.87183 22.3849 5.41614V4.06266C22.3849 3.45461 22.8623 2.97716 23.4704 2.97716C24.0784 2.97716 24.5559 3.45461 24.5559 4.06266V5.41614C25.8152 5.87183 26.7269 7.06588 26.7269 8.47703C26.7269 9.08508 26.2494 9.56253 25.6414 9.56253C25.0333 9.56253 24.5559 9.08508 24.5559 8.47703C24.5559 7.86898 24.0784 7.39153 23.4704 7.39153C22.8623 7.39153 22.3849 7.86898 22.3849 8.47703C22.3849 9.08508 22.8623 9.56253 23.4704 9.56253C25.2725 9.56253 26.7269 11.0169 26.7269 12.819Z'
        fill='#FFE470'
      />
      <path
        d='M6.10241 35.6869H1.68804C1.08847 35.6869 0.602539 35.201 0.602539 34.6014V19.332C0.602539 18.7325 1.08847 18.2465 1.68804 18.2465H3.93141C5.72983 18.2465 7.18791 19.7046 7.18791 21.503V34.6014C7.18791 35.201 6.70198 35.6869 6.10241 35.6869Z'
        fill='#FF4B00'
      />
      <path
        d='M26.7272 12.8191C26.7272 14.2302 25.8156 15.4243 24.5562 15.8802V17.1611C24.5562 17.7691 24.0788 18.2466 23.4707 18.2466V13.9046C24.0788 13.9046 24.5562 13.4271 24.5562 12.8191C24.5562 12.211 24.0788 11.7336 23.4707 11.7336V9.56256C25.2728 9.56256 26.7272 11.017 26.7272 12.8191Z'
        fill='#FFD400'
      />
      <path
        d='M23.4707 7.39153V2.97716C24.0788 2.97716 24.5562 3.45461 24.5562 4.06266V5.41614C25.8156 5.87183 26.7272 7.06588 26.7272 8.47703C26.7272 9.08508 26.2498 9.56253 25.6417 9.56253C25.0337 9.56253 24.5562 9.08508 24.5562 8.47703C24.5562 7.86898 24.0788 7.39153 23.4707 7.39153Z'
        fill='#FFD400'
      />
    </svg>
  )
}

export const ArrowRight2 = () => {
  return (
    <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.47174 3.14482L5.58266 0.255668C5.50019 0.173198 5.39027 0.12793 5.27307 0.12793C5.15574 0.12793 5.04588 0.173263 4.96341 0.255668L4.7011 0.51804C4.6187 0.600381 4.5733 0.710364 4.5733 0.827631C4.5733 0.944834 4.6187 1.05852 4.7011 1.14086L6.38655 2.83002H1.0318C0.790372 2.83002 0.599609 3.01903 0.599609 3.26052V3.63145C0.599609 3.87294 0.790372 4.081 1.0318 4.081H6.40568L4.70117 5.77959C4.61876 5.86206 4.57337 5.96905 4.57337 6.08632C4.57337 6.20346 4.61876 6.31201 4.70117 6.39441L4.96348 6.65594C5.04595 6.73841 5.1558 6.78335 5.27313 6.78335C5.39034 6.78335 5.50025 6.73783 5.58272 6.65536L8.47181 3.76627C8.55447 3.68354 8.59994 3.5731 8.59961 3.45571C8.59987 3.33792 8.55447 3.22742 8.47174 3.14482Z" fill="#FF0000"/>
    </svg>

  )
}